<template>
  <div class="player">
    <!-- <h1>{{ msg }}</h1> -->
    <div class="bottom-control">
      <button :class="{rewind:true, active:rewindInterval}"
              @click="rewind">
              <!-- @mousedown="onRewindStart" @touchstart="onRewindStart" 
              @mouseleave="onRewindStop" @mouseup="onRewindStop"
              @touchend="onRewindStop" @touchcancel="onRewindStop"> -->
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
            <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
            <text x="5" y="9.5" style="font: bold 3.5px sans-serif;">10s</text>
          </svg>
          <!-- <svg xmlns="http://www.w3.org/2000/svg"  height="100%" width="100%" fill="currentColor" class="bi bi-ff" viewBox="0 0 16 14">
            <path d="M 1,7.248 7.267,3.612 C 7.787,3.31 8.5,3.655 8.5,4.308 v 2.94 L 14.767,3.612 C 15.287,3.31 16,3.655 16,4.308 v 7.384 c 0,0.653 -0.713,0.998 -1.233,0.696 L 8.5,8.752 v 2.94 c 0,0.653 -0.713,0.998 -1.233,0.696 L 1,8.752 C -0.17187249,7.994113 -0.18413329,7.994113 1,7.248 Z M 7.5,4.633 1.696,8 7.5,11.367 Z m 7.5,0 L 9.196,8 15,11.367 Z"/>
          </svg> -->
        </div>
        <!-- <div class="label">Rev</div> -->
      </button>
      <button class="pause" @click="togglePlayback">
        <div class="icon">          
          <svg v-if="!playing" xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" fill="currentColor" class="bi bi-play" viewBox="0 0 14 14">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"/>
          </svg>
       
          <!-- <svg v-if="playing" xmlns="http://www.w3.org/2000/svg" height="100%" width="100%"  fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 14">
            <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
          </svg> -->
          <svg v-if="playing" xmlns="http://www.w3.org/2000/svg"  height="100%" width="100%" fill="currentColor" class="bi bi-pause" viewBox="0 0 16 14">
            <path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/>
          </svg>
        </div>
        <div class="label">{{ playing ? 'Pause' : 'Play' }}</div>
      </button>
      <button :class="{fastforward:true, active:fastForwardInterval}"
              @click="fastforward">
              <!-- @mousedown="onFastForwardStart" @touchstart="onFastForwardStart" 
              @mouseleave="onFastForwardStop" @mouseup="onFastForwardStop"
              @touchend="onFastForwardStop" @touchcancel="onFastForwardStop"> -->
        <div class="icon">
          <!-- <svg xmlns="http://www.w3.org/2000/svg"  height="100%" width="100%" fill="currentColor" class="bi bi-ff" viewBox="0 0 16 14">
            <path d="M 15,8.752 8.733,12.388 C 8.213,12.69 7.5,12.345 7.5,11.692 V 8.752 L 1.233,12.388 C 0.713,12.69 0,12.345 0,11.692 V 4.308 C 0,3.655 0.713,3.31 1.233,3.612 L 7.5,7.248 V 4.308 C 7.5,3.655 8.213,3.31 8.733,3.612 L 15,7.248 c 1.17897,0.746113 1.169442,0.746113 0,1.504 z M 1,4.633 v 6.734 L 6.804,8 Z m 7.5,0 v 6.734 L 14.304,8 Z"/>
          </svg> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
            <text x="5" y="9.5" style="font: bold 3.5px sans-serif;">30s</text>
          </svg>
        </div>
        <!-- <div class="label">Fwd</div> -->
      </button>
      <!-- <button @click="stop">Stop</button> -->
      <div class="seek">{{minutes}}:{{seconds}}</div>
      <!-- <span>Progress: {{ (progress * 100) }}%</span> -->

    </div>
  </div>
</template>

<script>
import VueHowler from '@/vue-howler';

export default {
  name: 'Player',
  mixins: [VueHowler],  
  props: {
    // msg: String
    trackPostTime: Number,
  },
  data () {
    return {
      inPost: false,
      fastForwardInterval: null,
      rewindInterval: null,
      seek_seconds: -1,
    }
  },
  created() {
    this.hookHowl();
  },
  methods: {
    hookHowl() {
      console.log("hooks created");
      this.$data._howl.on('seek', this.onSeek);
      this.$data._howl.on('load', this.onLoad);
      this.$data._howl.on('play', this.onPlay);
      this.$data._howl.on('stop', this.onStop);
      this.$data._howl.on('end', this.onEnd);
      this.$emit('time', 0);      
    },
    onSeek(e) {
      console.log('onSeek', e);
    },
    onLoad(e) {
      console.log('onLoad', e);
    },
    onPlay(e) {
      console.log('onPlay', e);
    },
    onStop(e) {
      console.log('onStop', e);
      // debugger; //eslint-disable-line
    },
    onEnd(e) {
      console.log('onEnd', e);
      if (!this.loop) {        
        this.setSeek(this.duration-1);  // don't go back to the beginning on end
        this.$emit('trackdone');
      }
    },
    rewind(e) {
      console.log('rewind', e);
      this.setSeek(this.seek-10);
    },
    // onRewindStart(e) {
    //   console.log('onRewindStart', e);
    //   if(!this.rewindInterval){
    //     this.setSeek(this.seek-10);
    //     this.rewindInterval = setInterval(() => {
    //       this.setSeek(this.seek-1);
    //     }, 200)
    //   }
    // },
    // onRewindStop(e) {
    //   console.log('onRewindStop', e);
    //   clearInterval(this.rewindInterval);
    //   this.rewindInterval = false;
    // },
    fastforward(e) {
      console.log('fastForward', e);
      let skip = Math.min(this.duration-this.seek-1, 30);
      // console.log("FF by", skip);
      this.setSeek(this.seek+skip);
    },
    // onFastForwardStart(e) {
    //   console.log('onFastForwardStart', e);
    //   if(!this.fastForwardInterval){
    //     this.setSeek(this.seek+30);
    //     this.fastForwardInterval = setInterval(() => {
    //       this.setSeek(this.seek+1.5);
    //     }, 150)
    //   }
    // },
    // onFastForwardStop(e) {
    //   console.log('onFastForwardStop', e);
    //   clearInterval(this.fastForwardInterval);
    //   this.fastForwardInterval = false;
    // },
  },
  computed: {
    minutes() {
      let min = Math.floor(this.seek / 60);
      return String(min);
    },
    seconds() {
      let sec = Math.floor(this.seek % 60);
      return String(sec).padStart(2,'0');
    },
  },
  watch: {
    seek(seek) {
      this.seek_seconds = parseInt(seek,10);
    },
    seek_seconds(secs) {
      this.$emit('time', secs); // only emit once a second
    },
    sources() {
      // when sources change, the Howl object is recreated, need to redo events
      // console.log("sources reloaded");
      this.hookHowl();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}

.bottom-control button.active {
  background-color: #555;
  color: #ddd;
}

.bottom-control button.pause {
  width: 15vh;
  height: 15vh;
}

.bottom-control button.fastforward, .bottom-control button.rewind {
  /* padding-bottom: 0.3vh; */
  padding-left: 0;
  padding-right: 0;
  padding-top: 3px;
}
.bottom-control button.rewind {
  /* padding-left: 1vw; */
}
.bottom-control button.fastforward {
  /* padding-right: 1vw; */
}

button .icon {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right:auto;
}
button.pause .icon {
  width: 85%;
  height: 75%;
}

.seek {
  padding-top: 0.5rem;
  color: grey;
}
</style>
